module.exports = __webpack_public_path__ + "img/de.94f33d9b.svg";